export const CompactScreenCriteria = 6 / 5;